import RecipientPicker from "./RecipientPicker";
import React, { useContext } from "react";
import { Box } from "@mui/material";
import FormType, { FieldConfigs } from "../../../../shared/components/FormType";
import { api } from "../../../../shared/hooks/api";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";
import { Customer } from "../../../../data/entities";

interface ExportMaterialFormProps {
    formData: any;
    standalone?: boolean;
    onChange: (data: any) => void;
}

export const ExportMaterialForm = ({ formData, onChange, standalone = false }: ExportMaterialFormProps) => {
    const [{ data: customers }] = api.get<Customer[]>("/customers/", { page: 1, page_size: 1000 }, standalone);
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const handleCustomerSelect = (customer: Customer) => {
        onChange({
            ...formData,
            department: customer?.name || "",
        });
    };

    const fields: FieldConfigs[] = [
        {
            label: "Kho xuất",
            type: "dropdown",
            key: "storage",
            options: [
                { text: "Kho 1", value: "Kho 1" },
                { text: "Kho 2", value: "Kho 2" },
            ],
            required: true,
        },
        {
            label: "Phương thức xuất",
            type: "dropdown",
            key: "export_method",
            options: [
                { text: "Xuất bán", value: "Xuất bán" },
                { text: "Xuất sản xuất", value: "Xuất sản xuất" },
                { text: "Xuất khác", value: "Xuất khác" },
            ],
            required: true,
        },
        {
            label: standalone ? "Đối tượng" : "Khách hàng",
            key: "department",
            type: standalone ? "custom" : "autocomplete",
            customComponent: standalone ? <RecipientPicker value={formData.department || ""} onSelect={name => onChange({ ...formData, department: name })} /> : undefined,
            options: customers?.results?.map((customer: Customer) => ({
                ...customer,
                text: customer.name,
                value: customer.name,
            })),
            noDataText: "Không tìm thấy khách hàng",
            onChange: handleCustomerSelect,
            required: true,
        },
        {
            label: "Người nhận",
            type: "text",
            key: "receiver_name",
        },
        {
            label: "Ngày xuất kho",
            type: "calendar",
            key: "export_date",
            required: true,
        },
        {
            label: "Ghi chú",
            type: "text",
            key: "note",
            required: false,
        },
    ];

    const getFields = () => {
        const isStorageKeeper = [ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role);
        if (isStorageKeeper) {
            return fields.filter((field: any) => field.label !== "Kho xuất");
        }

        return fields;
    };

    return (
        <Box sx={{ width: "100%" }}>
            <FormType
                title="Thông tin xuất kho"
                fields={getFields()}
                validated={false}
                requireData={formData}
                mergeFormData={onChange}
            />
        </Box>
    );
};
